import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const MyLabsHistoryPage = lazy(() => import("./MyLabsHistoryPage"));

const MyLabsHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MyLabsHistoryPage />
    </Suspense>
  );
};

export default MyLabsHistoryPageLazy;
